import Constants from "expo-constants";

const settings = {
  dev: {
    apiUrl: "http",
    imageUrl: "http",
  },
  staging: {
    apiUrl: "http",
    imageUrl: "http",
  },
  prod: {
    //Charliñe
    // apiUrl: "https://18.116.234.21:2022",     
    // imageUrl: "https://18.116.234.21:5000",    
    // chatUrl:  "https://18.116.234.21:7000", 

    //--------------------------------------------------------
    // *** Aws ***
    // Cuando esta en true la variable switchS3 se consultan y guardan
    //las imagenes en un bucket de aws S3. 
    switchS3: true,
    imageUrlS3: 'https://photosfixdplanet.s3.amazonaws.com/',
    //imageUrlS3: process.env.URLS3,

    // Cuando esta en false la variable switchS3 se consultan y guardan
    //las imagenes directamente del servidor.
    //switchS3: false,
    //-------------------------------------------------------

    //apiUrl: "http://18.116.234.21:2022",
    
    apiUrl: "https://dichapp.com",
    //apiUrl: process.env.URL,

  },
};

const getCurrentSettings = () => {
  //if (__DEV__) return settings.dev;
  //if (Constants.manifest.releaseChannel === "staging") return settings.staging;
  console.log("Current Settings:", Constants.manifest.releaseChannel + " - " + process.env.EXPO_PUBLIC_URLS3);
  return settings.prod;
};

export default getCurrentSettings()
//export default connectionConfig()